import { useCallback, useState, useEffect } from 'react';
import { useIntl } from 'react-intl';

import { FlexRow, Gap } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import { messages } from './messages';
import { IORDropdown } from '../../../../../../../../../components/ior-dropdown/ior-dropdown';
import { useIOR } from '../../../../../../../../../hooks/use-ior';
import { INT_PARAMETER } from '../../../../../../constants/parameter-name-for-update';

export const AddIOR = ({ onChange, inputValueProps }) => {
  const { activeIORs } = useIOR();
  const intl = useIntl();
  const [importerOfRecord, setImporterOfRecord] = useState(null);

  useEffect(() => {
    if (!inputValueProps?.intParameter) {
      return;
    }
    const iorFromId = activeIORs.find(({ id }) => id === inputValueProps.intParameter);
    setImporterOfRecord(iorFromId || null);
  }, [inputValueProps?.intParameter, activeIORs]);

  const onSelectionMade = useCallback(
    (selectedImporterOfRecord) => {
      setImporterOfRecord(selectedImporterOfRecord);
      onChange({
        [INT_PARAMETER]: selectedImporterOfRecord?.id,
      });
    },
    [onChange, setImporterOfRecord],
  );

  return (
    <FlexRow gap={Gap.Space4}>
      <Text textType={TextType.Label} value={messages.label} />
      <IORDropdown
        importerOfRecord={importerOfRecord}
        placeholder={intl.formatMessage(messages.placeholder)}
        updateImporterOfRecord={onSelectionMade}
      />
    </FlexRow>
  );
};
